import {type ReportViewRef} from '../reports/types';
import {type Viewer} from '../viewer/types';
import * as Normalize from './normalize';
import {replacePartImmutable, type ViewReducerState} from './reducerSupport';
import {isReportLikeViewType} from './report/types';
import type * as Types from './types';
import {type View, type ViewRef} from './types';

export function isOwnView(viewer: Viewer | undefined, view: View): boolean {
  return viewer != null && viewer.id === view.user.id;
}

export function isReportView(viewRef: ViewRef): viewRef is ReportViewRef {
  return isReportLikeViewType(viewRef.type);
}

export function copyObjectImmutable(
  state: ViewReducerState,
  fromRef: Types.AllPartRefs,
  ref: Types.AllPartRefs
) {
  const whole = Normalize.denormalize(state.parts, fromRef);
  const {ref: addedRef, parts: newParts} = Normalize.addObjImmutable(
    state.parts,
    fromRef.type,
    ref.viewID,
    whole
  );
  if (ref.type !== addedRef.type) {
    throw new Error('invalid action');
  }
  return replacePartImmutable({...state, parts: newParts}, ref, addedRef);
}
